import { render, staticRenderFns } from "./DocumentLibraryModal.vue?vue&type=template&id=2858af06&scoped=true"
import script from "./DocumentLibraryModal.vue?vue&type=script&lang=js"
export * from "./DocumentLibraryModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentLibraryModal.vue?vue&type=style&index=0&id=2858af06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2858af06",
  null
  
)

export default component.exports